// priority = order of preference
// 0 is reserved for current card used by loan

const order = {
    A1: {
        priority: 1
    },
    B1: {
        priority: 2
    },
    B2: {
        priority: 3
    },
    B3: {
        priority: 4
    },
    C1: {
        priority: 5
    }

};

module.exports = order;
